import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Schedules data to be sent to shinyapp at the next setTimeout(0).
// Batches multiple input calls into one websocket message.
var InputBatchSender = /*#__PURE__*/function () {
  // We need this field to satisfy the InputPolicy interface
  function InputBatchSender(shinyapp) {
    _classCallCheck(this, InputBatchSender);

    _defineProperty(this, "target", void 0);

    _defineProperty(this, "shinyapp", void 0);

    _defineProperty(this, "timerId", null);

    _defineProperty(this, "pendingData", {});

    _defineProperty(this, "reentrant", false);

    _defineProperty(this, "lastChanceCallback", []);

    this.shinyapp = shinyapp;
  }

  _createClass(InputBatchSender, [{
    key: "setInput",
    value: function setInput(nameType, value, opts) {
      this.pendingData[nameType] = value;

      if (!this.reentrant) {
        if (opts.priority === "event") {
          this._sendNow();
        } else if (!this.timerId) {
          this.timerId = setTimeout(this._sendNow.bind(this), 0);
        }
      }
    }
  }, {
    key: "_sendNow",
    value: function _sendNow() {
      if (this.reentrant) {
        console.trace("Unexpected reentrancy in InputBatchSender!");
      }

      this.reentrant = true;

      try {
        this.timerId = null;
        this.lastChanceCallback.forEach(function (callback) {
          return callback();
        });
        var currentData = this.pendingData;
        this.pendingData = {};
        this.shinyapp.sendInput(currentData);
      } finally {
        this.reentrant = false;
      }
    }
  }]);

  return InputBatchSender;
}();

export { InputBatchSender };